import React from "react";

export default function SimpleDivider({ ...props }) {
    return (
        <hr className="mb-3 mt-3" />
    )
}